// Availability module — the "does the dispenser have enough space for the order" API layer.
// Talks to the cubbie-availability-manager server.

window.Availability = {
  /**
   * Whether a specific cart fits on a given day, via POST /validateAvailability.
   * Note* an empty cart is allowed (it trivially fits)
   * Returns { cartFits, message, availableSpots, maxBoxesForOrder, boxesNeeded } for the cart box display.
   */
  async validateAvailability(locationHandle, date, cart) {
    if (cart == null || locationHandle == null || date == null) {
      throw new Error('validateAvailability missing required arguments');
    }

    const defaultErrorResult = {
      error: true,
      cartFits: false,
      message: 'Unable to verify dispenser availability. Please try again or contact support.',
      availableSpots: 0,
      maxBoxesForOrder: 0,
      boxesNeeded: 0,
    };

    // An empty cart needs no boxes, so it always fits. Checkout is still gated by /reserve, which rejects empty carts.
    if (cart.item_count === 0) {
      return { cartFits: true, message: '', availableSpots: null, maxBoxesForOrder: null, boxesNeeded: 0 };
    }

    try {
      const apiUrl = KROWN.settings.api_urls.cubbie_availability_app_url;
      if (!apiUrl) {
        console.warn('Cubbie availability API URL not configured');
        return defaultErrorResult;
      }

      const response = await fetch(`${apiUrl}/validateAvailability`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ locationHandle, date, cart }),
      });

      if (!response.ok) {
        console.error('Failed to validate availability:', response.status);
        return defaultErrorResult;
      }

      const result = await response.json();

      const availableSpots = result.availableSpots || 0;
      const maxBoxesForOrder = result.maxBoxesForOrder || 0;
      const boxesNeeded = result.boxesNeeded || 0;

      if (!result.cartFits) {
        const message =
          maxBoxesForOrder === 0
            ? 'No dispenser spots available for this date. Please select a different pickup day.'
            : `This order needs ${boxesNeeded} dispenser spots and only ${maxBoxesForOrder} will fit for this day.`;

        return { cartFits: false, message, availableSpots, maxBoxesForOrder, boxesNeeded };
      }

      return {
        cartFits: true,
        message: '',
        availableSpots,
        maxBoxesForOrder,
        boxesNeeded,
      };
    } catch (error) {
      console.error('Error validating availability:', error);
      return defaultErrorResult;
    }
  },
};
